import { StyledInvestmentBenchmarks } from './InvestmentBenchmarks.style';
import { StyledSubHeader } from '../Configuration.style';
import BenchmarkSelector from './BenchmarkSelector/BenchmarkSelector';
import PotentialSavingsToggler from './PotentialSavingsToggler';

const InvestmentBenchmarks = ({ formState }) => {
  return (
    <StyledInvestmentBenchmarks>
      <StyledSubHeader>Investment Benchmarks</StyledSubHeader>
      <PotentialSavingsToggler formState={formState} />
      <BenchmarkSelector formState={formState} />
    </StyledInvestmentBenchmarks>
  );
};

export default InvestmentBenchmarks;
